import React from 'react';

const DeclaracaoUnicaExportacaoContext = React.createContext();

export default DeclaracaoUnicaExportacaoContext;
